import { useEffect, useState, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import Accordion from 'react-bootstrap/Accordion';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from 'react-data-table-component';
import BeatLoader from 'react-spinners/BeatLoader';
import ArchiveModal from '../components/modals/archive';
import StatusModal from '../components/modals/status';
import AssignModal from '../components/modals/assign';
import IcoArrow from '../assets/ico-arrow';
import CustomLoader from '../components/custom-loader';
import { fetchOrders, updateStatus, selectAllOrders, resetStatus, resetOrders, updateAssignedUser, updateCaseManager, requestOrderCancellation} from '../reducers/orders-slice';
import { resetOrderDetails } from '../reducers/order-details-slice';
import FilterMethods from '../utility/filter-methods';
import { selectActiveFeatures, selectPortalUser } from '../reducers/auth-slice';
import { fetchUserNotified, selectUserNotified, incrementNotifiedCount, fetchNotifications, resetNotifications } from '../reducers/notifications-slice';
import NotificationModal from '../components/modals/notification';
import IcoMail from '../assets/ico-mail';
import ReassignCaseManagerModal from '../components/modals/reassign-case-manager';
import RequestOrderCancellationModal from '../components/modals/request-order-cancellation';

const Orders = () => {
    const [ordersLoaded, setOrdersLoaded] = useState(false);
    // eslint-disable-next-line
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedFirm, setSelectedFirm] = useState([]);
    const activeFeatures = useSelector(selectActiveFeatures);
    const [showDropdown, setShowDropdown] = useState(false);
    const [clearRows, setClearRows] = useState(false);
    const [allowNewOrders, setAllowNewOrders] = useState(true);
    //Setting the amount of orders initially visible on screen
    // const [visibleOrders, setVisibleOrders] = useState(15);


    /**
     * get orders
     */
    const dispatch = useDispatch();
    const orders = useSelector(selectAllOrders);
    const orderStatus = useSelector(state => state.orders.status);
    const portalUser = useSelector(selectPortalUser);
    const notificationStatus = useSelector(state => state.notifications.userNotifiedStatus)
    const notified = useSelector(state => state.notifications.notified);
    const navigate = useNavigate();
    const [sortedFilterOptions, setSortedFilterOptions] = useState([]);
    //loads variable that contains session storage item activeFilters
    const loadedFilters = JSON.parse(window.sessionStorage.getItem('activeFilters'));



    // fetch orders details on each initial render
    useEffect(() => {

        if (orderStatus === 'idle' && !ordersLoaded) {
            dispatch(resetOrderDetails());
            dispatch(resetOrders());
            dispatch(fetchOrders());
            dispatch(fetchUserNotified(portalUser.id));
        } else if (orderStatus === 'succeeded' && !ordersLoaded) {
            // anything that needs to happen AFTER 
            // the data has loaded (e.g. removing loading indicator)
            setOrdersLoaded(true);
            setSortedFilterOptions(sortFilterOptions(orders));
        } 
    }, [setOrdersLoaded, ordersLoaded, dispatch, orderStatus,]);

    // set when order details have been loaded
    useEffect(() => {
        if (ordersLoaded) {
            dispatch(resetStatus());
        }
    }, [dispatch, ordersLoaded]);

    useEffect(() => {
        setAllowNewOrders(portalUser && (portalUser.organization && portalUser.organization.status == 'Enabled'))
    }, [portalUser]);

    // Sort all filterable data alphabetically for use in Filter dropdown(s)
    const sortFilterOptions = (orders) => {
        var filterOptions = {};
        filterOptions.assignedGI = [...new Set([...orders].sort((a, b) => a.assignedGI.localeCompare(b.assignedGI)).map(order => order.assignedGI))];
        filterOptions.assignedFirm  = [...new Set([...orders].sort((a, b) => a.assignedFirm.localeCompare(b.assignedFirm)).map(order => order.assignedFirm))];
        filterOptions.caseName = [...new Set([...orders].sort((a, b) => a.caseName.localeCompare(b.caseName)).map(order => order.caseName))];
        filterOptions.investigationType = [...new Set([...orders].sort((a, b) => a.investigationType.localeCompare(b.investigationType)).map(order => order.investigationType))];
        filterOptions.firm = [...new Set([...orders].sort((a, b) => a.firm.localeCompare(b.firm)).map(order => order.firm))];
        filterOptions.status = [...new Set([...orders].sort((a, b) => a.status.localeCompare(b.status)).map(order => order.status))];

        return filterOptions;
    };

    //function to handle lazy loading of more orders
        // const loadMoreOrders = useCallback(() => {
        //     if (visibleOrders < orders.length) {
        //         setVisibleOrders(visibleOrders + 25); // Load 25 more orders
        //     }
        // }, [visibleOrders, orders]);
    
    // function to handle loading more orders once handleScroll breakpoint has been hit
        // const handleScroll = useCallback(() => {
        //     const tableContainer = document.getElementById('table-container-orders'); 
        //     if (tableContainer) {
        //       const tableHeight = tableContainer.clientHeight;
        //       const tableContentHeight = tableContainer.scrollHeight;
          
        //       if (tableContainer.scrollTop >= tableContentHeight - tableHeight - 25 && visibleOrders < orders.length) {
        //         loadMoreOrders();
        //       }
        //     }
        //   }, [loadMoreOrders, visibleOrders, orders]);
    
    //setting an eventListener to be called when handleScroll breakpoint is detected
    // useEffect(() => {
    //     const tableContainer = document.getElementById('table-container-orders');
    //     if (tableContainer) {
    //       tableContainer.addEventListener('scroll', handleScroll);
    //     }
    
    //     return () => {
    //       if (tableContainer) {
    //         tableContainer.removeEventListener('scroll', handleScroll);
    //       }
    //     };
    //   }, [handleScroll]);

    /**
     * handle notifications functionality
     */
    const [showNotificationsModal, setShowNotificationsModal] = useState(false);
    const handleNotificationsModal = (e) => {
        // e.preventDefault();
        window.sessionStorage.setItem("notified", "true");
        setShowNotificationsModal(false);
    }

    useEffect(() => {

        // this is for checking if there are new notifications (if the modal has been closed during the session)
        if (notificationStatus === 'succeeded' && window.sessionStorage.getItem("numNotifications") < notified && window.sessionStorage.getItem("notified") === "true" && !(activeFeatures.includes('f_FieldInvestigator_AssignRoles') || activeFeatures.includes('f_InternalInvestigator_AssignRoles'))) {
            window.sessionStorage.setItem("notified", "false");
        }
        // show the modal if the user has the flag set
        if (notificationStatus === 'succeeded' && notified > 0 && window.sessionStorage.getItem("notified") !== "true" && !(activeFeatures.includes('f_FieldInvestigator_AssignRoles') || activeFeatures.includes('f_InternalInvestigator_AssignRoles'))) {
            setShowNotificationsModal(true);
            window.sessionStorage.setItem("numNotifications", notified);
        }


    }, [dispatch, notificationStatus, ordersLoaded]);

    const handleViewNotifications = () => {
        window.sessionStorage.setItem("notified", "true");
        navigate('/orders/notifications');
        dispatch(resetNotifications());
    }

    /**
     * handle filters functionality
     */
    const [appliedFilters, setApplyFilters] = useState([]);
    const [filters, setFilters] = useState([]);
    const [displayedFilters, setDisplayedFilters] = useState("");

    //will populate the filters with the filters object in session storage if the object is not null, else it will set everything to empty
    useEffect(() => {
        if (loadedFilters != null && orderStatus === 'idle' && !ordersLoaded) {
            setFilters(loadedFilters);
            setDisplayedFilters(FilterMethods.concatFilters(loadedFilters));
            setApplyFilters(loadedFilters);
        }
    }, [loadedFilters, orderStatus, ordersLoaded])

    // if the toggle for show dropdown is true then it will load checked filters, breaking it out into a use effect fixed
    // issue of not loading on the first click since the function was running before the dropdown opened
    //this function runs everytime the dropdown is clicked
    useEffect(() => {
        if (showDropdown && loadedFilters != null) {
            FilterMethods.applyLoadedFilters(loadedFilters);
        }
    }, [showDropdown, loadedFilters]);

    const handleApplyFilters = (e) => {
        e.preventDefault();
        setDisplayedFilters(FilterMethods.concatFilters(filters));
        setApplyFilters(filters);
        //sets session storage variable to active filters checked
        window.sessionStorage.setItem("activeFilters", JSON.stringify(filters));
        setShowDropdown(false);
        // setVisibleOrders(15);
    }

    const handleClearFilters = (e) => {
        e.preventDefault();
        FilterMethods.clearFilters();
        setFilters([]);
        setApplyFilters([]);
        setDisplayedFilters("");
        setShowDropdown(false);
        //sets session storage variable to null
        window.sessionStorage.setItem("activeFilters", null);
        // setVisibleOrders(15);
    };

    // fetch all orders again after update
    const fetchAllOrdersAfterDispatch = (dispatchFunction) => {
        dispatchFunction.then(() => {
            dispatch(resetOrders());
            dispatch(fetchOrders());
        })
        // setVisibleOrders(15);
    }

    /**
     * handle the add new
     */
     const handleAddNew = () => {
        navigate("/intake/general-information");
    };

    /**
     * handle archive functionality
     */
    const [showArchiveModal, setShowArchiveModal] = useState(false);
    const handleCloseArchiveModal = () => {
        setShowArchiveModal(false);
    }
    const handleShowArchiveModal = () => setShowArchiveModal(true);

    const handleArchiveButton = (e) => {
        e.preventDefault();
        if (selectedRows.length > 0) {
            const dispatchFunc = dispatch(updateStatus({ orderIds: selectedRows, status: "Archived" }));
            fetchAllOrdersAfterDispatch(dispatchFunc);
        }
        handleCloseArchiveModal();
        setClearRows(!clearRows);
        setSelectedRows([]);
        // setVisibleOrders(15);
    };

    /**
     * handle status functionality
     */
    const [showStatusModal, setShowStatusModal] = useState(false);
    const handleCloseStatusModal = () => setShowStatusModal(false);
    const handleShowStatusModal = () => setShowStatusModal(true);

    // eslint-disable-next-line
    const [status, setStatus] = useState("");
    const handleStatusChange = (e) => {
        e.preventDefault();
        setStatus(e.target.value);

    };

    const handleStatusButton = (e) => {
        e.preventDefault();
        if (selectedRows.length > 0) {
            const dispatchFunc = dispatch(updateStatus({ orderIds: selectedRows, status }));
            fetchAllOrdersAfterDispatch(dispatchFunc);
        }
        handleCloseStatusModal();
    };


    /**
     * handle assign glucroft user functionality
     */
    const [showAssignModal, setShowAssignModal] = useState(false);
    const handleCloseAssignModal = () => setShowAssignModal(false);
    const handleShowAssignModal = () => setShowAssignModal(true);

    // eslint-disable-next-line
    const [user, setUser] = useState("");
    const handleUserChange = (e) => {
        e.preventDefault();
        setUser(e.target.value);
    };

    const handleAssignButton = (e) => {
        e.preventDefault();
        if (selectedRows.length > 0 && user !== "Select a User") {
            const dispatchFunc = dispatch(updateAssignedUser({ orderIds: selectedRows, user }));
            fetchAllOrdersAfterDispatch(dispatchFunc);
        }
        // setVisibleOrders(15)
        handleCloseAssignModal();
    };

    /**
     * handle cancel order request functionality
     */
    const [showRequestOrderCancellationModal, setshowRequestOrderCancellationModal] = useState(false);
    const handleShowRequestOrderCancellationModal = () => setshowRequestOrderCancellationModal(true);
    const handleCloseRequestOrderCancellationModal = () => setshowRequestOrderCancellationModal(false);

    const handleRequestOrderCancellationsButton = (value) => {
        if (selectedRows.length > 0) {
            const dispatchFunc = dispatch(requestOrderCancellation({ orderIds: selectedRows, cancellationReason: value.cancellationReason }));
            fetchAllOrdersAfterDispatch(dispatchFunc);
        }

        handleCloseRequestOrderCancellationModal();
    }


    /**
     * handle assign case Manager functionality
     */
    const [showReassignCaseManagerModal, setShowReassignCaseManagerModal] = useState(false);
    const handleCloseReassignCaseManagerModal = () => setShowReassignCaseManagerModal(false);
    const handleShowReassignCaseManagerModal = () => setShowReassignCaseManagerModal(true);

    const [caseManager, setCaseManager] = useState("");
    const handleReassignChange = (e) => {
        e.preventDefault();
        setCaseManager(e.target.value);
    };

    const handleReassignButton = (e) => {
        e.preventDefault();

        if (selectedRows.length > 0 && caseManager !== "Select a Case Manager") {
            const dispatchFunc = dispatch(updateCaseManager({ orderIds: selectedRows, caseManager }));
            fetchAllOrdersAfterDispatch(dispatchFunc);
        }

        handleCloseReassignCaseManagerModal();
    };

    /**
     * handle changing of selected rows in the table
     */
    const handleSelectedRowsChange = ({ selectedRows }) => {

        //Store selected Order Ids in state
        if (selectedRows.length > 0) {
            var orderIds = [];
            selectedRows.forEach(x => {
                orderIds.push(x.id);
            })        
            setSelectedRows(orderIds);

            //also store the firm names to reduce orders query in reassign manager modal
            var firmNames = [];
            selectedRows.forEach(x => {
                firmNames.push(x.firm);
            })        
            setSelectedFirm(firmNames);
            
        } else {
            setClearRows(!clearRows);
            setSelectedRows([]);
            setSelectedFirm([]);
        }
    };


    /**
     * setup orders table
     */
    const nonCaseManagerColumns = [
        {
            name: 'Order',
            selector: row => row.orderNumber,
            cell: row => row.status === 'Draft' ? <Link to={`/intake/general-information?orderId=${row.id}`} key={row.id}>{row.orderNumber}</Link> : <Link to={`/orders/order-details/${row.id}`} key={row.id}>{row.orderNumber}</Link>,
            sortable: true,
        },
        {
            name: 'Law Firm',
            selector: row => row.firm,
            sortable: true,
        },
        {
            name: 'Case Manager',
            selector: row => row.assignedFirm,
            sortable: true,
        },
        {
            name: <span title="Case Name">Case Name</span>,
            selector: row => row.caseName,
            cell: row => activeFeatures.includes('f_fieldInvestigatorView')  ? row.caseName : <Link to={`/orders/case-details/${row.caseId}`} key={`caseName${row.id}`}>{row.caseName}</Link>,
            sortable: true,
        },
        {
            name: 'Assigned (G.I.)',
            selector: row => row.assignedGI,
            sortable: true,
        },
        {
            name: 'Investigation Type',
            selector: row => row.investigationType,
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
        },
        {
            name: 'Submit Date',
            selector: row => row.start,
            cell: row => <span key={`startDate${row.id}`}>{new Date(row.start.endsWith('Z') ? row.start : row.start+"Z").toLocaleDateString()}</span>,
            sortable: true,
        },
        {
            name: 'Last Edit',
            selector: row => row.lastEdit,
            cell: row => <span key={`editDate${row.id}`}>{new Date(row.lastEdit.endsWith('Z') ? row.lastEdit : row.lastEdit+"Z").toLocaleDateString()}</span>,
            sortable: true,
        },
        {
            name: 'Notification',
            selector: row => row.attention,
            cell: row => ( row.attentionMessage != null && !activeFeatures.includes('f_InternalInvestigator_AssignRoles') && !activeFeatures.includes('f_FieldInvestigator_AssignRoles') ? <Link className='button note' to={`/orders/order-details/${row.id}#notifications`} title ={row.attentionMessage}><IcoMail /></Link> : null),
            sortable: true,
        },
    ];

    const caseManagerColumns = [
        {
            name: 'Order',
            selector: row => row.orderNumber,
            cell: row => row.status === 'Draft' ? <Link to={`/intake/general-information?orderId=${row.id}`} key={row.id}>{row.orderNumber}</Link> : <Link to={`/orders/order-details/${row.id}`} key={row.id}>{row.orderNumber}</Link>,
            sortable: true,
        },
        {
            name: 'Submit Date',
            selector: row => row.start,
            cell: row => <span key={`startDate${row.id}`}>{new Date(row.start.endsWith('Z') ? row.start : row.start+"Z").toLocaleDateString()}</span>,
            sortable: true,
        },
        {
            name: 'Case Manager',
            selector: row => row.assignedFirm,
            sortable: true,
        },
        {
            name: <span title="Case Name">Case Name</span>,
            selector: row => row.caseName,
            sortable: true,
        },
        {
            name: 'Investigation Type',
            selector: row => row.investigationType,
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
        },
        {
            name: 'Notification',
            selector: row => row.attention,
            cell: row => ( row.attentionMessage != null && !activeFeatures.includes('f_InternalInvestigator_AssignRoles') && !activeFeatures.includes('f_FieldInvestigator_AssignRoles') ? <Link className='button note' to={`/orders/order-details/${row.id}#notifications`} title ={row.attentionMessage}><IcoMail /></Link> : null),
            sortable: true,
        },
    ];

    const columns = activeFeatures.includes('f_CaseManagerView') ? caseManagerColumns : nonCaseManagerColumns;
    
    const conditionalRowStyles = [       
        {
            when: (row) => true,
            style: row => ({
                //If a row needs attention bold the font
                fontWeight: row.attention > 0 && !activeFeatures.includes('f_InternalInvestigator_AssignRoles') && !activeFeatures.includes('f_FieldInvestigator_AssignRoles') ? 600 : 'inherit',
                backgroundColor: row.colorCode === 1 ? '#FFC5B4' : row.colorCode === 2 ? '#FCFAD5' : row.colorCode === 3 ? '#B8EAA9' : 'inherit'
            })
        }
    ];

    const paginationComponentOptions = {
        noRowsPerPage: true,
    };

    // declaring filterdData in a variable so a slice can be made of only the visible orders on screen but its still filtering all orders which are loaded initially
    const filteredData = FilterMethods.filteredData(orders, appliedFilters);

      //function showing order totals below table
      const orderTotal = () => {
        const orderCount = filteredData ? filteredData.length : orders.length;

        return (
            <p>{orderCount} orders</p>
        )

    }

    return (
        <div className="page">
            {(orderStatus === 'loading') &&
                <div className="loader-container">
                    <BeatLoader color="#00818C" />
                </div>
            }



            <div>
                {showNotificationsModal && 
                    <NotificationModal 
                    showNotificationsModal={showNotificationsModal}
                    handleNotificationsModal={handleNotificationsModal}
                    handleViewNotifications={handleViewNotifications}
                    />
                }
            </div>



            <div className="page-header page-header-sticky"> 
                <div className="page-header-title">
                    <h1>Orders</h1>
                    <div className="page-header-title-filters">{displayedFilters}</div>
                </div>

                <div className="page-header-actions">
                    
                    {activeFeatures.includes('f_NewOrder') && allowNewOrders && <button className="button secondary" type="button" onClick={handleAddNew}>+ Add New Order</button>}

                    <Dropdown className="filter" align="end" show={showDropdown} onToggle={(isOpen) => setShowDropdown(isOpen)}>
                        <Dropdown.Toggle id="dropdown-filter" className="button primary filter">
                            Filter <IcoArrow />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Header className="center">
                                <button className="button primary" onClick={handleApplyFilters}>Apply</button>
                                <button className="button outlined primary" onClick={handleClearFilters}>Clear</button>
                            </Dropdown.Header>

                            <Accordion>
                                {!activeFeatures.includes('f_CaseManagerView') &&
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Aging Date</Accordion.Header>
                                        <Accordion.Body>
                                            <Form.Check type={'checkbox'} name={`agingDate`} id={`ad1`}>
                                                <Form.Check.Input type={'checkbox'} onClick={e => setFilters(FilterMethods.assignSelectedFilter(e.target.id, "colorCode", filters))} />
                                                <Form.Check.Label id={`ad1-label`}>Aged Out</Form.Check.Label>
                                            </Form.Check>
                                            <Form.Check type={'checkbox'} name={`agingDate`} id={`ad0`}>
                                                <Form.Check.Input type={'checkbox'} onClick={e => setFilters(FilterMethods.assignSelectedFilter(e.target.id, "colorCode", filters))} />
                                                <Form.Check.Label id={`ad0-label`}>Cleared</Form.Check.Label>
                                            </Form.Check>
                                            <Form.Check type={'checkbox'} name={`agingDate`} id={`ad2`}>
                                                <Form.Check.Input type={'checkbox'} onClick={e => setFilters(FilterMethods.assignSelectedFilter(e.target.id, "colorCode", filters))} />
                                                <Form.Check.Label id={`ad2-label`}>Waiting on Client</Form.Check.Label>
                                            </Form.Check>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                }
                                {!activeFeatures.includes('f_CaseManagerView') &&
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>Assigned (G.I.)</Accordion.Header>
                                        <Accordion.Body>
                                            {[...new Set(sortedFilterOptions.assignedGI)].map((assignedGI, i) => (
                                                <Form.Check type={'checkbox'} name={`assignedGI`} id={`agi${i}`} key={`agi${i}`}>
                                                    <Form.Check.Input type={'checkbox'} onClick={e => setFilters(FilterMethods.assignSelectedFilter(e.target.id, "assignedGI", filters))} />
                                                    <Form.Check.Label id={`agi${i}-label`}>{assignedGI}</Form.Check.Label>
                                                </Form.Check>
                                            ))}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                }
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Case Manager</Accordion.Header>
                                    <Accordion.Body>
                                        {[...new Set(sortedFilterOptions.assignedFirm)].map((assignedFirm, i) => (
                                            <Form.Check type={'checkbox'} name={`assignedFirm`} id={`af${i}`} key={`af${i}`}>
                                                <Form.Check.Input type={'checkbox'} onClick={e => setFilters(FilterMethods.assignSelectedFilter(e.target.id, "assignedFirm", filters))}/>
                                                <Form.Check.Label id={`af${i}-label`}>{assignedFirm}</Form.Check.Label>
                                            </Form.Check>
                                        ))}
                                    </Accordion.Body>
                                </Accordion.Item>
                                {!activeFeatures.includes('f_CaseManagerView') &&
                                    <Accordion.Item eventKey="3">
                                        <Accordion.Header>Investigation Type</Accordion.Header>
                                        <Accordion.Body>
                                            {[...new Set(sortedFilterOptions.investigationType)].map((investigationType, i) => (
                                                <Form.Check type={'checkbox'} name={`investigation-type`} id={`it${i}`} key={`it${i}`}>
                                                    <Form.Check.Input onClick={e => setFilters(FilterMethods.assignSelectedFilter(e.target.id, "investigationType", filters))} />
                                                    <Form.Check.Label id={`it${i}-label`}>{investigationType}</Form.Check.Label>
                                                </Form.Check>
                                            ))}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                }
                                {!activeFeatures.includes('f_CaseManagerView') &&
                                    <Accordion.Item eventKey="4">
                                        <Accordion.Header>Law Firm</Accordion.Header>
                                        <Accordion.Body>
                                            {[...new Set(sortedFilterOptions.firm)].map((firm, i) => (
                                                <Form.Check type={'checkbox'} name={`firm`} id={`lf${i}`} key={`lf${i}`}>
                                                    <Form.Check.Input type={'checkbox'} onClick={e => setFilters(FilterMethods.assignSelectedFilter(e.target.id, "firm", filters))} />
                                                    <Form.Check.Label id={`lf${i}-label`}>{firm}</Form.Check.Label>
                                                </Form.Check>
                                            ))}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                }
                                {!activeFeatures.includes('f_CaseManagerView') &&
                                    <Accordion.Item eventKey="5">
                                        <Accordion.Header>Status</Accordion.Header>
                                        <Accordion.Body>
                                            {[...new Set(sortedFilterOptions.status)].map((status, i) => (
                                                <Form.Check type={'checkbox'} name={`status`} id={`s${i}`} key={`s${i}`}>
                                                    <Form.Check.Input type={'checkbox'} onClick={e => setFilters(FilterMethods.assignSelectedFilter(e.target.id, "status", filters))} />
                                                    <Form.Check.Label id={`s${i}-label`}>{status}</Form.Check.Label>
                                                </Form.Check>
                                            ))}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                }
                                {activeFeatures.includes('f_CaseManagerView') &&
                                    <Accordion.Item eventKey="6">
                                        <Accordion.Header>Case Name</Accordion.Header>
                                        <Accordion.Body>
                                            {[...new Set(sortedFilterOptions.caseName)].map((caseName, i) => (
                                                <Form.Check type={'checkbox'} name={`case-name`} id={`it${i}`} key={`it${i}`}>
                                                    <Form.Check.Input onClick={e => setFilters(FilterMethods.assignSelectedFilter(e.target.id, "caseName", filters))} />
                                                    <Form.Check.Label id={`it${i}-label`}>{caseName}</Form.Check.Label>
                                                </Form.Check>
                                            ))}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                }
                            </Accordion>
                        </Dropdown.Menu>
                    </Dropdown>

                    <Dropdown className="action" align="end">
                        <Dropdown.Toggle id="dropdown-action" className="button tertiary action">
                            Choose an Actions <IcoArrow />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            { activeFeatures.includes('f_Archive') && <Dropdown.Item onClick={handleShowArchiveModal}>Archive</Dropdown.Item> }
                            { portalUser.userType !== 'portal' && <Dropdown.Item onClick={handleShowAssignModal}>Assign Glucroft User</Dropdown.Item> }
                            { activeFeatures.includes('f_ReassignCaseManager') && <Dropdown.Item onClick={handleShowReassignCaseManagerModal}>Reassign Case Manager</Dropdown.Item> }
                            { activeFeatures.includes('f_CancelOrder') && <Dropdown.Item onClick={handleShowRequestOrderCancellationModal}>Cancel Order Request</Dropdown.Item>}
                            { portalUser.userType !== 'portal' && <Dropdown.Item onClick={handleShowStatusModal}>Update Status</Dropdown.Item> }
                        </Dropdown.Menu>
                    </Dropdown>

                    {showArchiveModal &&
                        <ArchiveModal
                            showArchiveModal={showArchiveModal}
                            handleCloseArchiveModal={handleCloseArchiveModal}
                            handleArchiveButton={handleArchiveButton}
                        />
                    }

                    {showStatusModal &&
                        <StatusModal
                            showStatusModal={showStatusModal}
                            handleCloseStatusModal={handleCloseStatusModal}
                            handleStatusButton={handleStatusButton}
                            handleStatusChange={handleStatusChange}
                        />
                    }

                    {showAssignModal &&
                        <AssignModal
                            showAssignModal={showAssignModal}
                            handleCloseAssignModal={handleCloseAssignModal}
                            handleAssignButton={handleAssignButton}
                            handleUserChange={handleUserChange}
                            orderIds={selectedRows}
                        />
                    }

                    {showReassignCaseManagerModal &&
                        <ReassignCaseManagerModal
                            showReassignCaseManagerModal={showReassignCaseManagerModal}
                            handleCloseReassignCaseManagerModal={handleCloseReassignCaseManagerModal}
                            handleReassignButton={handleReassignButton}
                            handleReassignChange={handleReassignChange}
                            orderIds={selectedRows}
                            firmNames={selectedFirm}
                        />
                    }

                    {showRequestOrderCancellationModal &&
                        <RequestOrderCancellationModal
                            showRequestOrderCancellationModal={showRequestOrderCancellationModal}
                            handleCloseRequestOrderCancellationModal={handleCloseRequestOrderCancellationModal}
                            handleConfirmRequestOrderCancellationButton={handleRequestOrderCancellationsButton}
                        />
                    }
                </div>
            </div>
        <div className='page-table-container' id="table-container-orders">
            <div className="page-body no-padding">
                <DataTable
                    paginationComponentOptions={paginationComponentOptions}
                    columns={columns}
                    // data={filteredData.slice(0, visibleOrders)}
                    data={filteredData}
                    progressPending={orderStatus === 'loading'}
                    progressComponent={<CustomLoader />}
                    conditionalRowStyles={conditionalRowStyles}
                    selectableRows
                    onSelectedRowsChange={handleSelectedRowsChange}
                    clearSelectedRows={clearRows}
                />
              
            </div>
        </div>
            <div>
                {orderTotal()}
            </div>
    </div>
    );
}

export default Orders;
